import localize from '../../common/localize';

export default function ApplicationLogoVertical({ height, width, path }) {
  return (
    <img
      width={width}
      height={height}
      alt={localize.logo_alt}
      className="m-0"
      src={path ?? `${process.env.PUBLIC_URL}/img/app_loading_logo.png`}
    />
  );
}
